import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { UsersIcon } from '@heroicons/react/24/outline';

import { ROUTES } from '@/utils/routes';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import ScheduledLessonReportModal from '@/components/scheduled-lesson-report/ScheduledLessonReportModal';
import { Button, SmartTableCellProps } from '@/components/ui/daisy';
import useNewUiScope from '@/data/hook/shared/useNewUiScope';

import { ScheduledLessonWithKlass } from '../types';
import useToggle from '@/data/hook/useToggle';

export default function ActionsCell({
  item,
}: SmartTableCellProps<ScheduledLessonWithKlass>) {
  const { t } = useTranslation('translation', { keyPrefix: 'pendencies' });
  const navigate = useNavigate();
  const isModernReport = useNewUiScope('manageScheduledLessonReport');

  const { isOpen, open, close } = useToggle();

  const reportLink = ROUTES.CLASS.LESSON_REPORT(item.klass.id, item.id);

  const handleViewReport = () => {
    if (isModernReport) {
      open();
    } else {
      navigate(reportLink);
    }
  };

  return (
    <>
      <Button
        size="sm"
        color="warning"
        variant="soft"
        onClick={handleViewReport}
      >
        <UsersIcon className="w-4" />
        {t('viewReport')}
      </Button>

      <ConditionalRenderer condition={isOpen}>
        <ScheduledLessonReportModal
          scheduledLessonId={item.id}
          onClose={close}
        />
      </ConditionalRenderer>
    </>
  );
}
